import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { SpecTablePayload, SpecTableService } from 'src/app/service/spec-table/spec-table.service';

@Component({
  selector: 'app-spec-table',
  templateUrl: './spec-table.component.html',
  styleUrls: ['./spec-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SpecTableComponent implements OnInit {
  specProductHeaders: any;
  specProductValues: any;
  specSKUCode: any[] = [];
  hasDealerPrice = true;
  dealerPrices: DealerPrice[];
  currentProductServiceSubscription$: Subscription;

  private getSpecTable(code: string): Observable<any> {
    const specTablePayload: SpecTablePayload = {
      fields: 'DEFAULT',
      productCode: code,
      productOptions: 'SPEC_TABLE',
    };
    return this.spectableService.getSpecTable(specTablePayload);
  }

  constructor(
    protected currentProductService: CurrentProductService,
    private spectableService: SpecTableService,
    private cdr: ChangeDetectorRef,
    private dealerPriceService: DealerPriceService,
    private languageService: ShimanoLanguageService
  ) {}

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  ngOnInit(): void {
    this.currentProductServiceSubscription$ = this.currentProductService
      .getProduct()
      .pipe(
        switchMap((product: any) => this.getSpecTable(product.code)),
        map((data: any) => {
          let productLocalSKUCode: any = [];
          if (data !== undefined) {
            this.specProductHeaders = data.specTable.productHeaders;
            this.specProductValues = data.specTable.productValues;
            this.specProductValues.forEach((skucode: any) => {
              productLocalSKUCode.push(skucode.code);
            });
          }
          return productLocalSKUCode;
        }),
        tap((productLocalSKUCode: any) => this.getDealerPrices(productLocalSKUCode))
      )
      .subscribe();
  }

  checkTableId(skuValues: any, headerValues: any): string {
    const headerValue = headerValues.headerId;
    let sku: any;
    skuValues.forEach((skuValue: any) => {
      if (skuValue.headerId === headerValue) {
        sku = skuValue.value;
      }
    });
    return sku;
  }

  dealerPrice(productCode: string): string {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceByProductCode(this.dealerPrices, productCode);
    }
  }

  getDealerPrices(productCodes: any[]) {
    this.dealerPriceService
      .getDealerPricesByProductCodes(productCodes)
      .pipe(take(1))
      .subscribe((data) => {
        this.dealerPrices = data.dealerPrices;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.currentProductServiceSubscription$?.unsubscribe();
  }
}
